/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-use-before-define */
// @ts-nocheck

export const smartlookAppend = (key: string, ...params: Array<any>) => {
  if (!window?.smartlook) return;

  smartlook(key, ...params);
};
